export const environment = {
  production: true,
  apiUrl: 'https://kommunal-atlas.de',
  //wegweiserApiUrl: 'https://www.wegweiser-kommune.de/data-api/rest',
  wegweiserApiUrl: '/data-api/rest', // Backend proxy is used
};
